import './App.css';
import ProjectRoutes from './Routes/ProjectRoutes';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ToastContainer } from 'react-toastify';
import { GoogleOAuthProvider } from '@react-oauth/google';
import 'react-toastify/dist/ReactToastify.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useDispatch, useSelector } from 'react-redux';
import axiosInstance from 'Utils/Interceptor';
import {
  setHomePageData,
  setPakagePageBanner,
  setTestPageBanner
} from './Redux/features/APIsDataSlice';
import { useEffect } from 'react';
import { LoadScript } from '@react-google-maps/api';
import { Config } from 'Utils/Config';
import { setLoader } from './Redux/features/LoaderSlice';
import {
  setCartData,
  setWhishListData
} from './Redux/features/ParsistAPIsData';

import 'react-tooltip/dist/react-tooltip.css';

const queryClient = new QueryClient();

function App() {
  const { cityId } = useSelector((state) => state.location);
  const { token } = useSelector((state) => state?.login);
  const redux = useSelector((state) => state);

  const dispatch = useDispatch();

  const fetchHomeData = async () => {
    dispatch(setLoader(true));
    try {
      const response = await axiosInstance.get(
        `/api/user/dashboard?banner_type=desktop&city_id=${cityId}`
      );
      dispatch(setHomePageData(response.data?.data));
    } catch (error) {}
    dispatch(setLoader(false));
  };

  const fetchBanner = async () => {
    try {
      const response = await axiosInstance.get(
        `/api/user/banners?banner_page=Package&city_id=${cityId}&banner_type=desktop`
      );
      dispatch(setPakagePageBanner(response.data?.data));
    } catch (error) {}
  };

  const fetchBannerForTestPage = async () => {
    try {
      const response = await axiosInstance.get(
        `/api/user/banners?banner_page=Test&city_id=${cityId}&banner_type=desktop`
      );
      dispatch(setTestPageBanner(response.data?.data));
    } catch (error) {}
  };

  const fetchCartDataAndWishListData = async () => {
    try {
      const response = await axiosInstance.get(`api/user/mywishlist`);
      dispatch(setWhishListData(response.data?.data));
    } catch (error) {}

    try {
      const response = await axiosInstance.get(
        `/api/user/mycart?city_id=${cityId}`
      );
      dispatch(setCartData(response.data?.data));
    } catch (error) {}
  };

  useEffect(() => {
    if (cityId) {
      fetchHomeData();
      fetchBanner();
      fetchBannerForTestPage();
    }
  }, [cityId]);
  console.log(redux, 'redux');
  useEffect(() => {
    token && fetchCartDataAndWishListData();
  }, [token]);

  return (
    <QueryClientProvider client={queryClient}>
      <LoadScript
        googleMapsApiKey={Config.GOOGLE_MAPS_API_KEY}
        libraries={['places']}
      >
        <GoogleOAuthProvider clientId={Config.GOOGLE_MAPS_API_KEY}>
          <ProjectRoutes />
        </GoogleOAuthProvider>
      </LoadScript>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar
        style={{ zIndex: 9999999 }}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </QueryClientProvider>
  );
}

export default App;
